export const initialRows = {
  where: '',
  when: '',
  check_items: '',
  lack: '',
  trigger: '',
}